import React, { useEffect, useState } from 'react';
import { Container, Paper } from '@mui/material';
import RunningTradesTable from '../components/running-trades-table';

const HighRoeTrades = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      setCurrentUser(JSON.parse(userStr));
    }
  }, []);

  return (
    <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <RunningTradesTable
          currentUser={currentUser}
          maxRoe={-500}
          title="ROE < -500%"
          emptyMessage="No trades with ROE below -500%"
        />
      </Paper>
    </Container>
  );
};

export default HighRoeTrades;
